
import {
  Component, Prop, PropSync, Mixins,
} from 'vue-property-decorator';
import { ShipFrom } from '@/features/shipment/types';
import { ScheduleDataType } from '@/features/schedule-pickup/types';
import focusMixin from '@/features/common/mixins/focusMixin';
import PickupInfo from './PickupInfo.vue';

@Component({
  components: {
    PickupInfo,
  },
})
export default class PickupModal extends Mixins(focusMixin) {
  @PropSync('show', { required: true }) syncedShow!: boolean;

  @Prop({ required: true }) scheduleData!: ScheduleDataType;

  @Prop({ required: true }) fromAddress!: ShipFrom | null;

  @Prop({ required: false, default: false }) isLoading!: boolean;
}
